import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { catchError, map, of } from 'rxjs';
import { UserService } from '../../shared/services/user.service';

export const PASSWORD_CHANGE_REQUIRED_ROUTE = ['change-password', 'required'];

export const passwordChangeRequiredGuard: CanActivateFn = () => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const userService = inject(UserService);

  if (msalService.instance.getAllAccounts().length === 0) {
    return true;
  }

  return userService.getCurrentUser().pipe(
    map((user) => (user?.isPasswordChangeRequired ? router.createUrlTree(PASSWORD_CHANGE_REQUIRED_ROUTE) : true)),
    catchError(() => of(true))
  );
};
